import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

import { withDefaults } from 'vue'
import Icon from '@/components/atoms/Icon'

type PropsType = {
  text: string
  useRemoveBtn?: boolean
  tagColor?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Tag',
  props: {
    text: null,
    useRemoveBtn: { type: Boolean, default: false },
    tagColor: null
  },
  emits: ['click'],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["tag", __props.tagColor])
  }, [
    _createElementVNode("span", null, _toDisplayString(__props.text), 1),
    (__props.useRemoveBtn)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "tag_remove",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
        }, [
          _createVNode(_unref(Icon), {
            size: "12",
            color: "color-white",
            type: "close"
          })
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})